/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { ContactDto } from '../models/contact-dto';
import { CustomerContactListItemDto } from '../models/customer-contact-list-item-dto';
import { CustomerContactListItemDtoBaseResponse } from '../models/customer-contact-list-item-dto-base-response';
import { CustomerContactListItemDtoListBaseResponse } from '../models/customer-contact-list-item-dto-list-base-response';
import { CustomerContactListItemDtoPagedResponseBaseResponse } from '../models/customer-contact-list-item-dto-paged-response-base-response';
import { CustomerInvoiceAddressDto } from '../models/customer-invoice-address-dto';
import { CustomerInvoiceAddressDtoListBaseResponse } from '../models/customer-invoice-address-dto-list-base-response';
import { CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse } from '../models/customer-loadcell-response-dlm-paged-response-dlm-base-response';
import { CustomerLoadcellResponseListDlmBaseResponse } from '../models/customer-loadcell-response-list-dlm-base-response';
import { CustomerLoadcellSortBy } from '../models/customer-loadcell-sort-by';
import { CustomerResponse } from '../models/customer-response';
import { CustomerResponseBaseResponse } from '../models/customer-response-base-response';
import { CustomerResponseDlmBaseResponse } from '../models/customer-response-dlm-base-response';
import { CustomerResponseDlmPagedResponseDlmBaseResponse } from '../models/customer-response-dlm-paged-response-dlm-base-response';
import { CustomerResponseListBaseResponse } from '../models/customer-response-list-base-response';
import { CustomerResponsePagedResponseBaseResponse } from '../models/customer-response-paged-response-base-response';
import { CustomerSortBy } from '../models/customer-sort-by';
import { FormCustomerListDlmBaseResponse } from '../models/form-customer-list-dlm-base-response';
import { Int64ListDlmBaseResponse } from '../models/int-64-list-dlm-base-response';
import { OrderDirection } from '../models/order-direction';
import { PropertyFilter } from '../models/property-filter';

@Injectable({
  providedIn: 'root',
})
export class CustomerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiCustomerGetCustomersGet
   */
  static readonly ApiCustomerGetCustomersGetPath = '/api/Customer/get-customers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerGetCustomersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetCustomersGet$Plain$Response(params?: {

    /**
     * 0 &#x3D; Name
     * 
     * 1 &#x3D; Address
     * 
     * 2 &#x3D; Postcode
     * 
     * 3 &#x3D; TelephoneNo
     */
    Sort?: CustomerSortBy;
    IsDeleted?: boolean;
    LoadcellSearch?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerResponseDlmPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerGetCustomersGetPath, 'get');
    if (params) {
      rb.query('Sort', params.Sort, {});
      rb.query('IsDeleted', params.IsDeleted, {});
      rb.query('LoadcellSearch', params.LoadcellSearch, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerGetCustomersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetCustomersGet$Plain(params?: {

    /**
     * 0 &#x3D; Name
     * 
     * 1 &#x3D; Address
     * 
     * 2 &#x3D; Postcode
     * 
     * 3 &#x3D; TelephoneNo
     */
    Sort?: CustomerSortBy;
    IsDeleted?: boolean;
    LoadcellSearch?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerResponseDlmPagedResponseDlmBaseResponse> {

    return this.apiCustomerGetCustomersGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmPagedResponseDlmBaseResponse>) => r.body as CustomerResponseDlmPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerGetCustomersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetCustomersGet$Json$Response(params?: {

    /**
     * 0 &#x3D; Name
     * 
     * 1 &#x3D; Address
     * 
     * 2 &#x3D; Postcode
     * 
     * 3 &#x3D; TelephoneNo
     */
    Sort?: CustomerSortBy;
    IsDeleted?: boolean;
    LoadcellSearch?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerResponseDlmPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerGetCustomersGetPath, 'get');
    if (params) {
      rb.query('Sort', params.Sort, {});
      rb.query('IsDeleted', params.IsDeleted, {});
      rb.query('LoadcellSearch', params.LoadcellSearch, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerGetCustomersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetCustomersGet$Json(params?: {

    /**
     * 0 &#x3D; Name
     * 
     * 1 &#x3D; Address
     * 
     * 2 &#x3D; Postcode
     * 
     * 3 &#x3D; TelephoneNo
     */
    Sort?: CustomerSortBy;
    IsDeleted?: boolean;
    LoadcellSearch?: string;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerResponseDlmPagedResponseDlmBaseResponse> {

    return this.apiCustomerGetCustomersGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmPagedResponseDlmBaseResponse>) => r.body as CustomerResponseDlmPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerCustomerGet
   */
  static readonly ApiCustomerCustomerGetPath = '/api/Customer/customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerGet$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<CustomerResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerGet$Plain(params?: {
    id?: number;
  }): Observable<CustomerResponseDlmBaseResponse> {

    return this.apiCustomerCustomerGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmBaseResponse>) => r.body as CustomerResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerGet$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<CustomerResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerGetPath, 'get');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerGet$Json(params?: {
    id?: number;
  }): Observable<CustomerResponseDlmBaseResponse> {

    return this.apiCustomerCustomerGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmBaseResponse>) => r.body as CustomerResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerCustomerPost
   */
  static readonly ApiCustomerCustomerPostPath = '/api/Customer/customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerCustomerPost$Plain$Response(params?: {
    body?: CustomerResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerCustomerPost$Plain(params?: {
    body?: CustomerResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerCustomerPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerCustomerPost$Json$Response(params?: {
    body?: CustomerResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerCustomerPost$Json(params?: {
    body?: CustomerResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerCustomerPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerCustomerByNameGet
   */
  static readonly ApiCustomerCustomerByNameGetPath = '/api/Customer/customer-by-name';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerByNameGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerByNameGet$Plain$Response(params?: {
    name?: string;
  }): Observable<StrictHttpResponse<CustomerResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerByNameGetPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerByNameGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerByNameGet$Plain(params?: {
    name?: string;
  }): Observable<CustomerResponseDlmBaseResponse> {

    return this.apiCustomerCustomerByNameGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmBaseResponse>) => r.body as CustomerResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerByNameGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerByNameGet$Json$Response(params?: {
    name?: string;
  }): Observable<StrictHttpResponse<CustomerResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerByNameGetPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerByNameGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerByNameGet$Json(params?: {
    name?: string;
  }): Observable<CustomerResponseDlmBaseResponse> {

    return this.apiCustomerCustomerByNameGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmBaseResponse>) => r.body as CustomerResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerFormFilteredCustomersGet
   */
  static readonly ApiCustomerFormFilteredCustomersGetPath = '/api/Customer/form-filtered-customers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerFormFilteredCustomersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerFormFilteredCustomersGet$Plain$Response(params?: {
    filterText?: string;
  }): Observable<StrictHttpResponse<FormCustomerListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerFormFilteredCustomersGetPath, 'get');
    if (params) {
      rb.query('filterText', params.filterText, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormCustomerListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerFormFilteredCustomersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerFormFilteredCustomersGet$Plain(params?: {
    filterText?: string;
  }): Observable<FormCustomerListDlmBaseResponse> {

    return this.apiCustomerFormFilteredCustomersGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<FormCustomerListDlmBaseResponse>) => r.body as FormCustomerListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerFormFilteredCustomersGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerFormFilteredCustomersGet$Json$Response(params?: {
    filterText?: string;
  }): Observable<StrictHttpResponse<FormCustomerListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerFormFilteredCustomersGetPath, 'get');
    if (params) {
      rb.query('filterText', params.filterText, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormCustomerListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerFormFilteredCustomersGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerFormFilteredCustomersGet$Json(params?: {
    filterText?: string;
  }): Observable<FormCustomerListDlmBaseResponse> {

    return this.apiCustomerFormFilteredCustomersGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<FormCustomerListDlmBaseResponse>) => r.body as FormCustomerListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerCustomerLoadcellsGet
   */
  static readonly ApiCustomerCustomerLoadcellsGetPath = '/api/Customer/customer-loadcells';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerLoadcellsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerLoadcellsGet$Plain$Response(params?: {
    CustomerId?: number;

    /**
     * 0 &#x3D; LoadcellId
     * 
     * 1 &#x3D; SerialNumber
     * 
     * 2 &#x3D; Status
     * 
     * 3 &#x3D; Priority
     */
    Sort?: CustomerLoadcellSortBy;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerLoadcellsGetPath, 'get');
    if (params) {
      rb.query('CustomerId', params.CustomerId, {});
      rb.query('Sort', params.Sort, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerLoadcellsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerLoadcellsGet$Plain(params?: {
    CustomerId?: number;

    /**
     * 0 &#x3D; LoadcellId
     * 
     * 1 &#x3D; SerialNumber
     * 
     * 2 &#x3D; Status
     * 
     * 3 &#x3D; Priority
     */
    Sort?: CustomerLoadcellSortBy;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse> {

    return this.apiCustomerCustomerLoadcellsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse>) => r.body as CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerLoadcellsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerLoadcellsGet$Json$Response(params?: {
    CustomerId?: number;

    /**
     * 0 &#x3D; LoadcellId
     * 
     * 1 &#x3D; SerialNumber
     * 
     * 2 &#x3D; Status
     * 
     * 3 &#x3D; Priority
     */
    Sort?: CustomerLoadcellSortBy;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerLoadcellsGetPath, 'get');
    if (params) {
      rb.query('CustomerId', params.CustomerId, {});
      rb.query('Sort', params.Sort, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerLoadcellsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerLoadcellsGet$Json(params?: {
    CustomerId?: number;

    /**
     * 0 &#x3D; LoadcellId
     * 
     * 1 &#x3D; SerialNumber
     * 
     * 2 &#x3D; Status
     * 
     * 3 &#x3D; Priority
     */
    Sort?: CustomerLoadcellSortBy;
    PageIndex?: number;
    PageSize?: number;
    SearchTerm?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse> {

    return this.apiCustomerCustomerLoadcellsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse>) => r.body as CustomerLoadcellResponseDlmPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerUnquotedCustomerLoadcellsGet
   */
  static readonly ApiCustomerUnquotedCustomerLoadcellsGetPath = '/api/Customer/unquoted-customer-loadcells';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerUnquotedCustomerLoadcellsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerUnquotedCustomerLoadcellsGet$Plain$Response(params?: {
    customerId?: number;
  }): Observable<StrictHttpResponse<CustomerLoadcellResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerUnquotedCustomerLoadcellsGetPath, 'get');
    if (params) {
      rb.query('customerId', params.customerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerLoadcellResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerUnquotedCustomerLoadcellsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerUnquotedCustomerLoadcellsGet$Plain(params?: {
    customerId?: number;
  }): Observable<CustomerLoadcellResponseListDlmBaseResponse> {

    return this.apiCustomerUnquotedCustomerLoadcellsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerLoadcellResponseListDlmBaseResponse>) => r.body as CustomerLoadcellResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerUnquotedCustomerLoadcellsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerUnquotedCustomerLoadcellsGet$Json$Response(params?: {
    customerId?: number;
  }): Observable<StrictHttpResponse<CustomerLoadcellResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerUnquotedCustomerLoadcellsGetPath, 'get');
    if (params) {
      rb.query('customerId', params.customerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerLoadcellResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerUnquotedCustomerLoadcellsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerUnquotedCustomerLoadcellsGet$Json(params?: {
    customerId?: number;
  }): Observable<CustomerLoadcellResponseListDlmBaseResponse> {

    return this.apiCustomerUnquotedCustomerLoadcellsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerLoadcellResponseListDlmBaseResponse>) => r.body as CustomerLoadcellResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerCustomerPressureLoadcellsGet
   */
  static readonly ApiCustomerCustomerPressureLoadcellsGetPath = '/api/Customer/customer-pressure-loadcells';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerPressureLoadcellsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerPressureLoadcellsGet$Plain$Response(params?: {
    customerId?: number;
  }): Observable<StrictHttpResponse<Int64ListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerPressureLoadcellsGetPath, 'get');
    if (params) {
      rb.query('customerId', params.customerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Int64ListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerPressureLoadcellsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerPressureLoadcellsGet$Plain(params?: {
    customerId?: number;
  }): Observable<Int64ListDlmBaseResponse> {

    return this.apiCustomerCustomerPressureLoadcellsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Int64ListDlmBaseResponse>) => r.body as Int64ListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerPressureLoadcellsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerPressureLoadcellsGet$Json$Response(params?: {
    customerId?: number;
  }): Observable<StrictHttpResponse<Int64ListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerCustomerPressureLoadcellsGetPath, 'get');
    if (params) {
      rb.query('customerId', params.customerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Int64ListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerPressureLoadcellsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerPressureLoadcellsGet$Json(params?: {
    customerId?: number;
  }): Observable<Int64ListDlmBaseResponse> {

    return this.apiCustomerCustomerPressureLoadcellsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Int64ListDlmBaseResponse>) => r.body as Int64ListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerEditCustomerPost
   */
  static readonly ApiCustomerEditCustomerPostPath = '/api/Customer/edit-customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerEditCustomerPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditCustomerPost$Plain$Response(params?: {
    body?: CustomerResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerEditCustomerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerEditCustomerPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditCustomerPost$Plain(params?: {
    body?: CustomerResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerEditCustomerPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerEditCustomerPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditCustomerPost$Json$Response(params?: {
    body?: CustomerResponse
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerEditCustomerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerEditCustomerPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditCustomerPost$Json(params?: {
    body?: CustomerResponse
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerEditCustomerPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerDeleteCustomerPost
   */
  static readonly ApiCustomerDeleteCustomerPostPath = '/api/Customer/delete-customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerDeleteCustomerPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerDeleteCustomerPost$Plain$Response(params?: {
    body?: CustomerResponse
  }): Observable<StrictHttpResponse<CustomerResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerDeleteCustomerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerDeleteCustomerPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerDeleteCustomerPost$Plain(params?: {
    body?: CustomerResponse
  }): Observable<CustomerResponseDlmBaseResponse> {

    return this.apiCustomerDeleteCustomerPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmBaseResponse>) => r.body as CustomerResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerDeleteCustomerPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerDeleteCustomerPost$Json$Response(params?: {
    body?: CustomerResponse
  }): Observable<StrictHttpResponse<CustomerResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerDeleteCustomerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerDeleteCustomerPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerDeleteCustomerPost$Json(params?: {
    body?: CustomerResponse
  }): Observable<CustomerResponseDlmBaseResponse> {

    return this.apiCustomerDeleteCustomerPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseDlmBaseResponse>) => r.body as CustomerResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerDeleteLoadcellPost
   */
  static readonly ApiCustomerDeleteLoadcellPostPath = '/api/Customer/delete-loadcell';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerDeleteLoadcellPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDeleteLoadcellPost$Plain$Response(params?: {
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerDeleteLoadcellPostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerDeleteLoadcellPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDeleteLoadcellPost$Plain(params?: {
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerDeleteLoadcellPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerDeleteLoadcellPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDeleteLoadcellPost$Json$Response(params?: {
    loadcellId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerDeleteLoadcellPostPath, 'post');
    if (params) {
      rb.query('loadcellId', params.loadcellId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerDeleteLoadcellPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDeleteLoadcellPost$Json(params?: {
    loadcellId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerDeleteLoadcellPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerRestorePost
   */
  static readonly ApiCustomerRestorePostPath = '/api/Customer/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerRestorePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerRestorePost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerRestorePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerRestorePost$Plain(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerRestorePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerRestorePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerRestorePost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerRestorePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerRestorePost$Json(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerRestorePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerImportCustomerCsvPost
   */
  static readonly ApiCustomerImportCustomerCsvPostPath = '/api/Customer/import-customer-csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerImportCustomerCsvPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportCustomerCsvPost$Plain$Response(params?: {
    body?: string
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerImportCustomerCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerImportCustomerCsvPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportCustomerCsvPost$Plain(params?: {
    body?: string
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerImportCustomerCsvPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerImportCustomerCsvPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportCustomerCsvPost$Json$Response(params?: {
    body?: string
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerImportCustomerCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerImportCustomerCsvPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportCustomerCsvPost$Json(params?: {
    body?: string
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerImportCustomerCsvPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerImportContactCsvPost
   */
  static readonly ApiCustomerImportContactCsvPostPath = '/api/Customer/import-contact-csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerImportContactCsvPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportContactCsvPost$Plain$Response(params?: {
    body?: string
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerImportContactCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerImportContactCsvPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportContactCsvPost$Plain(params?: {
    body?: string
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerImportContactCsvPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerImportContactCsvPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportContactCsvPost$Json$Response(params?: {
    body?: string
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerImportContactCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerImportContactCsvPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerImportContactCsvPost$Json(params?: {
    body?: string
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerImportContactCsvPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerImportFixPrimaryContactsPost
   */
  static readonly ApiCustomerImportFixPrimaryContactsPostPath = '/api/Customer/import-fix-primary-contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerImportFixPrimaryContactsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerImportFixPrimaryContactsPost$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerImportFixPrimaryContactsPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerImportFixPrimaryContactsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerImportFixPrimaryContactsPost$Plain(params?: {
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerImportFixPrimaryContactsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerImportFixPrimaryContactsPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerImportFixPrimaryContactsPost$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerImportFixPrimaryContactsPostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerImportFixPrimaryContactsPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerImportFixPrimaryContactsPost$Json(params?: {
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCustomerImportFixPrimaryContactsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerSearchAllGet
   */
  static readonly ApiCustomerSearchAllGetPath = '/api/Customer/search-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerSearchAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchAllGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<CustomerResponseListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerSearchAllGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerSearchAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchAllGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<CustomerResponseListBaseResponse> {

    return this.apiCustomerSearchAllGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseListBaseResponse>) => r.body as CustomerResponseListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerSearchAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchAllGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<CustomerResponseListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerSearchAllGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerSearchAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchAllGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<CustomerResponseListBaseResponse> {

    return this.apiCustomerSearchAllGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseListBaseResponse>) => r.body as CustomerResponseListBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerSearchContactsGet
   */
  static readonly ApiCustomerSearchContactsGetPath = '/api/Customer/search-contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerSearchContactsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchContactsGet$Plain$Response(params?: {
    searchTerm?: string;
    companyId?: number;
    includeBlankNames?: boolean;
    archived?: boolean;
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerSearchContactsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('companyId', params.companyId, {});
      rb.query('includeBlankNames', params.includeBlankNames, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerSearchContactsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchContactsGet$Plain(params?: {
    searchTerm?: string;
    companyId?: number;
    includeBlankNames?: boolean;
    archived?: boolean;
  }): Observable<CustomerContactListItemDtoListBaseResponse> {

    return this.apiCustomerSearchContactsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoListBaseResponse>) => r.body as CustomerContactListItemDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerSearchContactsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchContactsGet$Json$Response(params?: {
    searchTerm?: string;
    companyId?: number;
    includeBlankNames?: boolean;
    archived?: boolean;
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerSearchContactsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('companyId', params.companyId, {});
      rb.query('includeBlankNames', params.includeBlankNames, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerSearchContactsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerSearchContactsGet$Json(params?: {
    searchTerm?: string;
    companyId?: number;
    includeBlankNames?: boolean;
    archived?: boolean;
  }): Observable<CustomerContactListItemDtoListBaseResponse> {

    return this.apiCustomerSearchContactsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoListBaseResponse>) => r.body as CustomerContactListItemDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerPaginatedCompaniesGet
   */
  static readonly ApiCustomerPaginatedCompaniesGetPath = '/api/Customer/paginated-companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerPaginatedCompaniesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedCompaniesGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerResponsePagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerPaginatedCompaniesGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponsePagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerPaginatedCompaniesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedCompaniesGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerResponsePagedResponseBaseResponse> {

    return this.apiCustomerPaginatedCompaniesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponsePagedResponseBaseResponse>) => r.body as CustomerResponsePagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerPaginatedCompaniesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedCompaniesGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerResponsePagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerPaginatedCompaniesGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponsePagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerPaginatedCompaniesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedCompaniesGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerResponsePagedResponseBaseResponse> {

    return this.apiCustomerPaginatedCompaniesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponsePagedResponseBaseResponse>) => r.body as CustomerResponsePagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerPaginatedContactsGet
   */
  static readonly ApiCustomerPaginatedContactsGetPath = '/api/Customer/paginated-contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerPaginatedContactsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedContactsGet$Plain$Response(params?: {
    IncludeBlankNames?: boolean;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerPaginatedContactsGetPath, 'get');
    if (params) {
      rb.query('IncludeBlankNames', params.IncludeBlankNames, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerPaginatedContactsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedContactsGet$Plain(params?: {
    IncludeBlankNames?: boolean;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerContactListItemDtoPagedResponseBaseResponse> {

    return this.apiCustomerPaginatedContactsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoPagedResponseBaseResponse>) => r.body as CustomerContactListItemDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerPaginatedContactsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedContactsGet$Json$Response(params?: {
    IncludeBlankNames?: boolean;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerPaginatedContactsGetPath, 'get');
    if (params) {
      rb.query('IncludeBlankNames', params.IncludeBlankNames, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerPaginatedContactsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerPaginatedContactsGet$Json(params?: {
    IncludeBlankNames?: boolean;
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<CustomerContactListItemDtoPagedResponseBaseResponse> {

    return this.apiCustomerPaginatedContactsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoPagedResponseBaseResponse>) => r.body as CustomerContactListItemDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerToggleArchiveContactPost
   */
  static readonly ApiCustomerToggleArchiveContactPostPath = '/api/Customer/toggle-archive-contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerToggleArchiveContactPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerToggleArchiveContactPost$Plain$Response(params?: {
    isArchive?: boolean;
    body?: CustomerContactListItemDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerToggleArchiveContactPostPath, 'post');
    if (params) {
      rb.query('isArchive', params.isArchive, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerToggleArchiveContactPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerToggleArchiveContactPost$Plain(params?: {
    isArchive?: boolean;
    body?: CustomerContactListItemDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerToggleArchiveContactPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerToggleArchiveContactPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerToggleArchiveContactPost$Json$Response(params?: {
    isArchive?: boolean;
    body?: CustomerContactListItemDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerToggleArchiveContactPostPath, 'post');
    if (params) {
      rb.query('isArchive', params.isArchive, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerToggleArchiveContactPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerToggleArchiveContactPost$Json(params?: {
    isArchive?: boolean;
    body?: CustomerContactListItemDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerToggleArchiveContactPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerContactGet
   */
  static readonly ApiCustomerContactGetPath = '/api/Customer/contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerContactGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerContactGet$Plain$Response(params?: {
    contactId?: number;
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerContactGetPath, 'get');
    if (params) {
      rb.query('contactId', params.contactId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerContactGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerContactGet$Plain(params?: {
    contactId?: number;
  }): Observable<CustomerContactListItemDtoBaseResponse> {

    return this.apiCustomerContactGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoBaseResponse>) => r.body as CustomerContactListItemDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerContactGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerContactGet$Json$Response(params?: {
    contactId?: number;
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerContactGetPath, 'get');
    if (params) {
      rb.query('contactId', params.contactId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerContactGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerContactGet$Json(params?: {
    contactId?: number;
  }): Observable<CustomerContactListItemDtoBaseResponse> {

    return this.apiCustomerContactGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoBaseResponse>) => r.body as CustomerContactListItemDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerAddContactPost
   */
  static readonly ApiCustomerAddContactPostPath = '/api/Customer/add-contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAddContactPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddContactPost$Plain$Response(params?: {
    body?: CustomerContactListItemDto
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerAddContactPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAddContactPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddContactPost$Plain(params?: {
    body?: CustomerContactListItemDto
  }): Observable<CustomerContactListItemDtoBaseResponse> {

    return this.apiCustomerAddContactPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoBaseResponse>) => r.body as CustomerContactListItemDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAddContactPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddContactPost$Json$Response(params?: {
    body?: CustomerContactListItemDto
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerAddContactPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAddContactPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddContactPost$Json(params?: {
    body?: CustomerContactListItemDto
  }): Observable<CustomerContactListItemDtoBaseResponse> {

    return this.apiCustomerAddContactPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoBaseResponse>) => r.body as CustomerContactListItemDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerEditContactPut
   */
  static readonly ApiCustomerEditContactPutPath = '/api/Customer/edit-contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerEditContactPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditContactPut$Plain$Response(params?: {
    body?: CustomerContactListItemDto
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerEditContactPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerEditContactPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditContactPut$Plain(params?: {
    body?: CustomerContactListItemDto
  }): Observable<CustomerContactListItemDtoBaseResponse> {

    return this.apiCustomerEditContactPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoBaseResponse>) => r.body as CustomerContactListItemDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerEditContactPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditContactPut$Json$Response(params?: {
    body?: CustomerContactListItemDto
  }): Observable<StrictHttpResponse<CustomerContactListItemDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerEditContactPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerContactListItemDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerEditContactPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerEditContactPut$Json(params?: {
    body?: CustomerContactListItemDto
  }): Observable<CustomerContactListItemDtoBaseResponse> {

    return this.apiCustomerEditContactPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerContactListItemDtoBaseResponse>) => r.body as CustomerContactListItemDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerAddCustomerAndContactFromLeadPost
   */
  static readonly ApiCustomerAddCustomerAndContactFromLeadPostPath = '/api/Customer/add-customer-and-contact-from-lead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAddCustomerAndContactFromLeadPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddCustomerAndContactFromLeadPost$Plain$Response(params?: {
    body?: ContactDto
  }): Observable<StrictHttpResponse<CustomerResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerAddCustomerAndContactFromLeadPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAddCustomerAndContactFromLeadPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddCustomerAndContactFromLeadPost$Plain(params?: {
    body?: ContactDto
  }): Observable<CustomerResponseBaseResponse> {

    return this.apiCustomerAddCustomerAndContactFromLeadPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseBaseResponse>) => r.body as CustomerResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAddCustomerAndContactFromLeadPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddCustomerAndContactFromLeadPost$Json$Response(params?: {
    body?: ContactDto
  }): Observable<StrictHttpResponse<CustomerResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerAddCustomerAndContactFromLeadPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAddCustomerAndContactFromLeadPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddCustomerAndContactFromLeadPost$Json(params?: {
    body?: ContactDto
  }): Observable<CustomerResponseBaseResponse> {

    return this.apiCustomerAddCustomerAndContactFromLeadPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerResponseBaseResponse>) => r.body as CustomerResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerGetInvoiceAddressesGet
   */
  static readonly ApiCustomerGetInvoiceAddressesGetPath = '/api/Customer/get-invoice-addresses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerGetInvoiceAddressesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetInvoiceAddressesGet$Plain$Response(params?: {
    customerId?: number;
  }): Observable<StrictHttpResponse<CustomerInvoiceAddressDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerGetInvoiceAddressesGetPath, 'get');
    if (params) {
      rb.query('customerId', params.customerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerInvoiceAddressDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerGetInvoiceAddressesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetInvoiceAddressesGet$Plain(params?: {
    customerId?: number;
  }): Observable<CustomerInvoiceAddressDtoListBaseResponse> {

    return this.apiCustomerGetInvoiceAddressesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerInvoiceAddressDtoListBaseResponse>) => r.body as CustomerInvoiceAddressDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerGetInvoiceAddressesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetInvoiceAddressesGet$Json$Response(params?: {
    customerId?: number;
  }): Observable<StrictHttpResponse<CustomerInvoiceAddressDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerGetInvoiceAddressesGetPath, 'get');
    if (params) {
      rb.query('customerId', params.customerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerInvoiceAddressDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerGetInvoiceAddressesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGetInvoiceAddressesGet$Json(params?: {
    customerId?: number;
  }): Observable<CustomerInvoiceAddressDtoListBaseResponse> {

    return this.apiCustomerGetInvoiceAddressesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CustomerInvoiceAddressDtoListBaseResponse>) => r.body as CustomerInvoiceAddressDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerAddInvoiceAddressPost
   */
  static readonly ApiCustomerAddInvoiceAddressPostPath = '/api/Customer/add-invoice-address';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAddInvoiceAddressPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddInvoiceAddressPost$Plain$Response(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerAddInvoiceAddressPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAddInvoiceAddressPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddInvoiceAddressPost$Plain(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerAddInvoiceAddressPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAddInvoiceAddressPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddInvoiceAddressPost$Json$Response(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerAddInvoiceAddressPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAddInvoiceAddressPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerAddInvoiceAddressPost$Json(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerAddInvoiceAddressPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerUpdateInvoiceAddressPut
   */
  static readonly ApiCustomerUpdateInvoiceAddressPutPath = '/api/Customer/update-invoice-address';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerUpdateInvoiceAddressPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerUpdateInvoiceAddressPut$Plain$Response(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerUpdateInvoiceAddressPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerUpdateInvoiceAddressPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerUpdateInvoiceAddressPut$Plain(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerUpdateInvoiceAddressPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerUpdateInvoiceAddressPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerUpdateInvoiceAddressPut$Json$Response(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerUpdateInvoiceAddressPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerUpdateInvoiceAddressPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCustomerUpdateInvoiceAddressPut$Json(params?: {
    body?: CustomerInvoiceAddressDto
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerUpdateInvoiceAddressPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiCustomerArchiveInvoiceAddressDelete
   */
  static readonly ApiCustomerArchiveInvoiceAddressDeletePath = '/api/Customer/archive-invoice-address';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerArchiveInvoiceAddressDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerArchiveInvoiceAddressDelete$Plain$Response(params?: {
    invoiceAddressId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerArchiveInvoiceAddressDeletePath, 'delete');
    if (params) {
      rb.query('invoiceAddressId', params.invoiceAddressId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerArchiveInvoiceAddressDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerArchiveInvoiceAddressDelete$Plain(params?: {
    invoiceAddressId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerArchiveInvoiceAddressDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerArchiveInvoiceAddressDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerArchiveInvoiceAddressDelete$Json$Response(params?: {
    invoiceAddressId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerService.ApiCustomerArchiveInvoiceAddressDeletePath, 'delete');
    if (params) {
      rb.query('invoiceAddressId', params.invoiceAddressId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCustomerArchiveInvoiceAddressDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerArchiveInvoiceAddressDelete$Json(params?: {
    invoiceAddressId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiCustomerArchiveInvoiceAddressDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
